module.exports = __webpack_public_path__ + "img/cloudComputing.ab98e764.jpg";